import {Grid} from '@primer/react-brand/esm'

import {ColorDivider} from '../ColorDivider/ColorDivider'
import {CustomerStory, type CustomerStoryProps} from './CustomerStory/CustomerStory'

import Styles from './CustomerStories.module.css'

export interface CustomerStoriesProps {
  a11y: {
    title: string
  }
  items: CustomerStoryProps[]
}

export const defaultProps: Partial<CustomerStoriesProps> = {}

export const CustomerStories = (props: CustomerStoriesProps) => {
  const initializedProps: CustomerStoriesProps = {...defaultProps, ...props}
  const {a11y, items} = initializedProps

  return (
    <div className={Styles['CustomerStories']}>
      <h2 className="visually-hidden">{a11y.title}</h2>
      <div className={Styles['CustomerStories__gridContent']}>
        <Grid columnGap="none" rowGap="none" enableGutters={false}>
          <Grid.Column span={12} className={Styles['CustomerStories__dividerColumn']}>
            <div className={Styles['CustomerStories__divider']}>
              <ColorDivider variant="3" isThick hasDucky />
            </div>
          </Grid.Column>

          {items.map(item => (
            <Grid.Column key={item.cta.url} span={{xsmall: 12, large: 4}} className={Styles['CustomerStories__column']}>
              <CustomerStory {...item} />
            </Grid.Column>
          ))}
        </Grid>
      </div>
    </div>
  )
}
